import { useEffect, useRef, useState } from "react";
import { MdOutlineKeyboardArrowDown, MdCheck } from "react-icons/md";

const CurrencyDropdown = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedCurrency, setSelectedCurrency] = useState({
    code: "US",
    name: "United States",
    symbol: "$",
    label: "$ United States",
  });
  const dropdownRef = useRef(null);

  const currencies = [
    { code: "FR", name: "France", symbol: "€", label: "€ France" },
    { code: "UK", name: "United Kingdom", symbol: "£", label: "£ United Kingdom" },
    { code: "IN", name: "India", symbol: "₹", label: "₹ India" },
    { code: "JP", name: "Japan", symbol: "¥", label: "¥ Japan" },
    { code: "US", name: "United States", symbol: "$", label: "$ United States" },
  ];

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="relative inline-block text-left" ref={dropdownRef}>
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center justify-between gap-5 px-4 h-[42px] min-w-[170px] rounded-lg border text-white text-sm md:text-base font-normal hover:border-white/40 transition-all duration-200 cursor-pointer shadow-sm"
        style={{
          backgroundColor: "hsl(235.4, 17.8%, 14.3%)",
          borderColor: "hsl(240, 10%, 32%)",
        }}
      >
        <span className="whitespace-nowrap">{selectedCurrency.label}</span>
        <MdOutlineKeyboardArrowDown
          size={18}
          className={`text-gray-300 transition-transform duration-200 shrink-0 ${
            isOpen ? "rotate-180" : ""
          }`}
        />
      </button>

      {isOpen && (
        <div
          className="absolute right-0 top-full mt-2 w-56 rounded-lg border shadow-2xl p-1.5 z-[9999999]"
          style={{
            backgroundColor: "hsl(235.4, 17.8%, 14.3%)",
            borderColor: "hsl(240, 10%, 32%)",
          }}
        >
          {currencies.map((curr) => {
            const isSelected = curr.code === selectedCurrency.code;
            return (
              <button
                key={curr.code}
                type="button"
                onClick={() => {
                  setSelectedCurrency(curr);
                  setIsOpen(false);
                }}
                className={`w-full flex items-center gap-2.5 px-3 py-2.5 rounded-md text-xs md:text-sm font-normal text-left transition-all duration-150 cursor-pointer ${
                  isSelected
                    ? "bg-[#25233b] border text-white"
                    : "text-gray-300 hover:bg-[#25233b]/60 hover:text-white border border-transparent"
                }`}
                style={
                  isSelected
                    ? { borderColor: "hsl(240, 10%, 32%)" }
                    : undefined
                }
              >
                <div className="w-4 flex items-center justify-center shrink-0">
                  {isSelected && <MdCheck size={16} className="text-white" />}
                </div>
                <span className="whitespace-nowrap">{curr.label}</span>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default CurrencyDropdown;
